<template>
    <div class="trip-book">
      <div class="date-div">
        <div class="sub-til">
          <img src="../../assets/images/home/date.png" alt="">
          <span>游玩日期：</span>
          <span>{{useStartDate}}</span>
        </div>
        <!-- <div class="common-time-list">
          <div
            @click="handleSelectDate(item, index)"
            v-for="(item, index) in dateList"
            :key="index"
            :class="[(selectDateIndex === index && !otherDate) ? 'active' : '']"
            >
            <p>{{item.dateText}}</p>
            <p class="font14">{{item.text}}</p>
          </div>
          <div class="other-date" @click="handleShowDate">
            <span v-if="!otherDate">更多日期</span>
            <span v-else>{{otherDate}}</span>
            <img src="../../assets/images/home/right-arrow.png" alt="">
            <el-date-picker
              class="hide-date"
              ref="startDate"
              v-model="otherDate"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              :picker-options="setDateDisabled"
              @change="handleSelectOtherDate"
            >
            </el-date-picker>
          </div>
        </div> -->
      </div>
      <div class="interval-list-div" v-if="intervalList.length > 0">
        <div class="sub-til">
          <img src="../../assets/images/home/clock.png" alt="">
          <span>入园时间</span>
          <span v-if="intervalObj">：{{intervalObj.reservationBeginTime + '-' + intervalObj.reservationEndTime}}</span>
        </div>
        <!-- <div class="common-time-list">
          <div
            @click="handleSelectInterval(item)"
            v-for="(item, index) in intervalList"
            :key="index"
              :class="[intervalObj && intervalObj.reservationTemplateId === item.reservationTemplateId ? 'active' : '', item.disabled ? 'disabled':'']"
            >
            <p>{{item.reservationBeginTime + '-' + item.reservationEndTime}}</p>
            <p class="font14">余：{{item.surplusStockNum}}</p>
          </div>
        </div> -->
      </div>
      <div class="pro-list">
        <div v-for="(item, index) in proList" :key="index">
          <div class="flex-between">
            <div class="name">{{item.merchIndustryName}} - {{item.goodsName}}</div>
            <div class="price">
              <span class="ft16 c-r">¥</span>
              <span class="c-r">{{item.salePrice}}</span>
              <span>/张</span>
            </div>
          </div>
          <!-- 游玩人数 -->
          <div class="people-num">
            <div class="sub-til">
              <span>游玩人数</span>
            </div>
            <div class="common-time-list">
              <div :class="[Number(item.otherNumber) === (numberListItemIndex + 1) ? 'active' : '']"
                @click="handleSelectNumber(numberListItemIndex, index)"
                v-for="(numberListItem, numberListItemIndex) in numberList"
                :key="numberListItemIndex">{{numberListItem}}人</div>
              <div class="other-number">
                <el-input @blur="handleBlur(index)" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" class="other" v-model="item.otherNumber"></el-input>
              </div>
            </div>
          </div>
          <!-- 游客信息 -->
          <template v-if="item.visitorList.length > 0 && (item.optionCode === 'ALL_VISITOR' || item.optionCode === 'A_VISITOR')">
            <div class="sub-til mt40">
              <span>游客信息</span>
            </div>
            <el-table class="confirm-table-trip" :data="item.visitorList" :show-header="false">
              <el-table-column width="50">
                <template slot-scope="scope">
                  <span class="num">{{scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column width="160">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.visitorName" placeholder="游客姓名"></el-input>
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot-scope="scope">
                  <el-select class="w100" v-model="scope.row.visitorCertificateType" placeholder="证件类型">
                    <el-option
                      v-for="item in certificateTypes"
                      :key="item.code"
                      :label="item.value"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column width="220">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.visitorCertificateNo" placeholder="请输入证件号码"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="操作">
                <template slot-scope="scope">
                  <img v-if="item.visitorList.length > 1" class="delete-btn" @click="handleDelete(index, scope.$index)" src="../../assets/images/home/red-del.png" alt="">
                  <!-- <el-button class="reset-btn" @click="handleReset(index, scope.$index)">重置</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
      <el-form ref="formVisitor" :model="formData" label-width="120px">
        <div class="visitorMsg">
          <div class="headline">
            联系人信息
            <span class="sub">(请准确填写，以免无法接收订单信息)</span>
          </div>
          <div class="msgForm">
            <el-form-item label="联系人手机号" :prop="`contactMobile`" :rules="[{required: true, validator: validateMobile, trigger: ['change', 'blur']}]">
              <el-input v-model="formData.contactMobile" placeholder="请输入联系人手机号码" style="width:340px"></el-input>
            </el-form-item>
            <el-form-item label="手机验证码" :prop="`code`" v-if="codeshow" :rules="[{required: true, message: '请输入验证码', trigger: 'blur' }]">
              <el-input
                placeholder="请输入验证码"
                v-model="formData.code"
                style="width:210px;margin-right:10px;"
              ></el-input>
              <el-button
                class="verification-btn"
                type="primary"
                style="width:120px;"
                @click="getVerificationCode"
                :disabled="!verificationBtn"
              >
                <template v-if="verificationBtn">发送验证码</template>
                <template v-else>重新获取({{verificationTime}})</template>
              </el-button>
            </el-form-item>
            <el-form-item v-if="needContactCardNo" label="身份证号" prop="contactCardNo" class="mt20" :rules="[{required: true, validator: validateCert, trigger: ['change', 'blur']}]">
              <el-input v-model="formData.contactCardNo" placeholder="请输入联系人身份证号" style="width:340px"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="submitOrder">
          <div class="flex-between">
            <span>数量</span>
            <span>共{{Number(count)}}张</span>
          </div>
          <div class="flex-between">
            <span>总额</span>
            <span class="highLight price"><span class="ft16">¥</span>{{total}}</span>
          </div>
          <div class="submitBtn" @click="submitBtn('formVisitor')">去支付</div>
        </div>
      </el-form>
    </div>
</template>

<script>
import { formatDate, validaCellPhone, validaIDCardNo } from '@/utils/validate'
import { qucikBuyCode, sendCode, createOrder, cardtypeList } from '@/api/buyTicket'
import { findIntervalListByIndustry, getProductDetail } from '@/api/buyTicket_xqs'
import { clearInterval, setInterval } from 'timers'
import { config } from '@/constant/config'
export default {
  components: {},
  data () {
    return {
      // 游玩日期
      dateList: [],
      selectDateIndex: -1,
      otherDate: null,
      useStartDate: formatDate('yyyy-MM-dd', new Date()),
      // 入园时间
      isOpenInterval: false,
      intervalList: [],
      intervalObj: {},
      proList: [],
      certificateTypes: [],
      numberList: [1, 2, 3, 4, 5],
      formData: {
        contactMobile: null,
        contactCardNo: null,
        contactCardType: '1',
        code: ''
      },
      verificationBtn: true,
      verificationTime: 60,
      total: 0, // 总价
      count: 0, // 票数
      timer: null,
      codeshow: false,
      ticketInfo: false,
      expireTimeOption: {
        disabledDate (date) {
          return (
            date.getTime() < Date.now() + 1000 * 3600 * 24 * 2
          )
        }
      },
      hasIdCard: true,
      needContactCardNo: false
    }
  },
  computed: {
    // 日期禁用
    setDateDisabled () {
      return {
        disabledDate (time) {
          if (time.getTime() < new Date().getTime() - 24 * 60 * 60 * 1000) {
            return true
          }
        }
      }
    }
  },
  created () {
    // this.getDate()
    this.cardtypeList()
    const proList = JSON.parse(this.$route.query.proList) // 列表产品信息
    const merchIndustryName = this.$route.query.merchIndustryName
    this.proList = proList.map(val => {
      val.visitorList = []
      val.optionCode = null
      val.surplusStock = 0
      val.merchIndustryName = merchIndustryName
      return val
    })
    this.goodsIdList = this.proList.map(val => val.goodsId)
    this.useStartDate = this.$route.query.useStartDate
    this.getGoodsDetail('isFirst')
    this.isOpenInterval = this.$route.query.isOpenInterval === 'true'
    this.merchIndustryId = this.$route.query.merchIndustryId
    if (this.$route.query.reservationTemplateId) {
      this.reservationTemplateId = this.$route.query.reservationTemplateId
      this.findIntervalListByIndustry()
    }
  },
  methods: {
    // 去支付
    submitBtn (formName) {
      if (!this.validateInfo()) {
        return
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {
            merchId: config.MERCHID,
            contactMobile: this.formData.contactMobile,
            contactCardType: this.formData.contactCardNo ? '1' : null,
            contactCardNo: this.formData.contactCardNo
          }
          const uniteTripCreateList = []
          this.proList.forEach(val => {
            const visitorList = val.visitorList.filter(item => item.visitorName && item.visitorCertificateNo)
            uniteTripCreateList.push({
              goodsId: val.goodsId,
              intervalStockCalenderId: this.intervalObj ? this.intervalObj.intervalStockCalenderId : null,
              quantity: val.otherNumber,
              useStartDate: this.useStartDate,
              visitorList
            })
          })
          data.uniteTripCreateList = uniteTripCreateList
          createOrder(data).then(res => {
            if (res.code === 0) {
              this.$router.push({
                path: '/payOrder',
                query: {
                  orderNo: res.data
                }
              })
            } else {
              this.$message({
                message: res.error,
                type: 'error'
              })
            }
          })
        }
      })
    },
    // 支付前验证
    validateInfo () {
      if (this.ticketInfo) {
        this.$message.warning('未查询到票信息')
        return false
      } else if (this.intervalList.length > 0 && !this.intervalObj) {
        this.$message.warning('请选择入园时间')
        return false
      } else if (this.intervalObj && this.count > this.intervalObj.surplusStockNum) {
        this.$message.warning('当前时段库存不足')
        return false
      }
      let j = 0
      try {
        this.proList.forEach((val, index) => {
          const visitorList = val.visitorList.filter(item => item.visitorName && item.visitorCertificateNo)
          if (val.optionCode === 'A_VISITOR') {
            if (visitorList.length === 0) {
              j = j + 1
              throw new Error(`【${val.goodsName}】至少完善一位游客信息`)
            }
            val.visitorList.forEach((v, i) => {
              if ((v.visitorName && !v.visitorCertificateNo) || (!v.visitorName && v.visitorCertificateNo)) {
                j = j + 1
                throw new Error(`请将【${val.goodsName}】第${i + 1}个游客信息填写完整`)
              } else if (v.visitorCertificateNo && v.visitorCertificateType === '1' && !validaIDCardNo(v.visitorCertificateNo)) {
                j = j + 1
                throw new Error(`【${val.goodsName}】第${i + 1}个游客的身份证号码有误`)
              }
            })
          } else if (val.optionCode === 'ALL_VISITOR') {
            if (visitorList.length !== val.otherNumber) {
              j = j + 1
              throw new Error(`请将【${val.goodsName}】的游客信息填写完整`)
            }
            val.visitorList.forEach((v, i) => {
              if (v.visitorCertificateNo && v.visitorCertificateType === '1' && !validaIDCardNo(v.visitorCertificateNo)) {
                j = j + 1
                throw new Error(`【${val.goodsName}】第${i + 1}个游客的身份证号码有误`)
              }
            })
          }
        })
      } catch (e) {
        this.$message.warning(e.message)
        throw e
      }
      if (j > 0) {
        return false
      }
      if (!this.formData.contactMobile || this.formData.contactMobile === '') {
        this.$message.warning('请输入联系人手机号')
        return false
      } else if (!validaCellPhone(this.formData.contactMobile)) {
        this.$message.warning('联系人手机号格式不正确')
        return false
      } else if (this.needContactCardNo && (!this.formData.contactCardNo || this.formData.contactCardNo === '')) {
        this.$message.warning('请输入联系人身份证号')
        return false
      } else if (this.needContactCardNo && !validaIDCardNo(this.formData.contactCardNo)) {
        this.$message.warning('联系人身份证号格式不正确')
        return false
      }
      return true
    },
    // 选中日期
    handleSelectDate (item, index) {
      this.selectDateIndex = index
      this.otherDate = null
      this.useStartDate = item.date
      this.getGoodsDetail()
      if (this.isOpenInterval) {
        this.findIntervalListByIndustry()
      }
    },
    // 选择其他日期
    handleSelectOtherDate () {
      this.selectDateIndex = -1
      this.useStartDate = this.otherDate
      this.getGoodsDetail()
      if (this.isOpenInterval) {
        this.findIntervalListByIndustry()
      }
    },
    handleShowDate () {
      this.$refs['startDate'].focus()
    },
    // 选择分时预约
    handleSelectInterval (item) {
      if (item.disabled) {
        return
      }
      this.intervalObj = item
      this.reservationTemplateId = item.reservationTemplateId
    },
    // 选择数量
    handleSelectNumber (number, index) {
      this.$set(this.proList[index], 'otherNumber', ++number)
      this.dealVisitorList(index)
    },
    // 填写其他数量
    handleBlur (index) {
      let quantity = this.proList[index].otherNumber
      const n = Number(quantity)
      if (isNaN(Number(n))) {
        this.$message.warning('请输入正确的数值')
        quantity = 1
      } else if (n > 100) {
        this.$message.warning('数量过多')
        quantity = 1
      } else if (quantity == null || quantity === '' || quantity < 1) {
        this.$message.warning('数量需大于0')
        quantity = 1
      }
      this.$set(this.proList[index], 'otherNumber', quantity)
      this.dealVisitorList(index)
    },
    // 获取产品详情
    getGoodsDetail (isFirst) {
      getProductDetail({
        useDate: this.useStartDate,
        isDistribution: 'F',
        goodsIdList: this.goodsIdList
      }).then(res => {
        if (res.code === 0) {
          if (res.data && res.data.length > 0) {
            res.data.forEach(val => {
              const index = this.proList.findIndex(good => good.goodsId === val.goodsId)
              this.$set(this.proList[index], 'salePrice', val.salePrice)
              this.$set(this.proList[index], 'surplusStock', val.surplusStock)
              if (isFirst) {
                const obj = val.ruleInfoOptionList.find(rule => rule.ruleCode === 'REAL_NAME')
                if (obj.optionCode === 'TICKET_HOLDER') {
                  this.needContactCardNo = true
                }
                this.$set(this.proList[index], 'optionCode', obj.optionCode)
              }
              if (this.proList[index].optionCode === 'ALL_VISITOR' || this.proList[index].optionCode === 'A_VISITOR') {
                if (isFirst || this.proList[index].visitorList.length === 0) {
                  for (let i = 0; i < this.proList[index].otherNumber; i++) {
                    this.proList[index].visitorList.push({
                      visitorName: null,
                      visitorCertificateType: this.hasIdCard ? '1' : '',
                      visitorCertificateNo: null
                    })
                  }
                } else {
                  this.dealVisitorList(index)
                }
              }
            })
            this.ticketInfo = false
            this.countAll()
          } else {
            this.ticketInfo = true
            this.$message.warning('未查询到票信息')
          }
        } else {
          this.$message.error(res.error)
        }
      })
    },
    // 游客信息处理
    dealVisitorList (index) {
      if (this.proList[index].optionCode === 'ALL_VISITOR' || this.proList[index].optionCode === 'A_VISITOR') {
        const visitorList = JSON.parse(JSON.stringify(this.proList[index].visitorList))
        for (let i = 0; i < this.proList[index].otherNumber; i++) {
          if (visitorList[i] == null) {
            visitorList.push({
              visitorName: null,
              visitorCertificateType: this.hasIdCard ? '1' : '',
              visitorCertificateNo: null
            })
          }
        }
        visitorList.length = this.proList[index].otherNumber
        this.proList[index].visitorList = visitorList
        this.countAll()
      } else {
        this.countAll()
      }
    },
    // 删除游客信息
    handleDelete (index, i) {
      this.proList[index].visitorList.splice(i, 1)
      this.proList[index].otherNumber--
      this.countAll()
    },
    // 获取分时段
    findIntervalListByIndustry () {
      this.intervalList = []
      this.intervalObj = null
      findIntervalListByIndustry({
        goodsIdList: this.goodsIdList,
        merchIndustryId: this.merchIndustryId,
        useStartDate: this.useStartDate
      }).then(res => {
        if (res.code === 0 && res.data.length > 0) {
          this.intervalList = res.data.map(item => {
            item.disabled = false
            const day = this.useStartDate
            const endTime = new Date(day + ' ' + item.reservationEndTime + ':00').getTime()
            const now = new Date().getTime()
            if (item.surplusStockNum <= 0 || now >= endTime) {
              // 没库存 || 过期
              item.disabled = true
            }
            if ((this.reservationTemplateId === item.reservationTemplateId) && !item.disabled) {
              this.intervalObj = item
            }
            return item
          })
        }
      })
    },
    // 计算价格和数量
    countAll () {
      let count = 0
      let total = 0
      this.proList.forEach(val => {
        total += Number(val.otherNumber) * Number(val.salePrice)
        count += Number(val.otherNumber)
      })
      this.count = count
      this.total = total.toFixed(2)
    },
    GetDateStr (AddDayCount) {
      var dd = new Date()
      dd.setDate(dd.getDate() + AddDayCount)// 获取AddDayCount天后的日期
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1// 获取当前月份的日期
      var M = m < 10 ? '0' + m : m
      var d = dd.getDate()
      var D = d < 10 ? '0' + d : d
      return [y + '-' + M + '-' + D, m + '月' + d + '日']
    },
    // 获取三天日期
    getDate () {
      this.dateList.push({
        text: '今天',
        date: this.GetDateStr(0)[0],
        dateText: this.GetDateStr(0)[1]
      })
      this.dateList.push({
        text: '明天',
        date: this.GetDateStr(1)[0],
        dateText: this.GetDateStr(1)[1]
      })
      this.dateList.push({
        text: this.getWeekday(new Date(this.GetDateStr(2)[0]).getDay()),
        date: this.GetDateStr(2)[0],
        dateText: this.GetDateStr(2)[1]
      })
      this.dateList.push({
        text: this.getWeekday(new Date(this.GetDateStr(3)[0]).getDay()),
        date: this.GetDateStr(3)[0],
        dateText: this.GetDateStr(3)[1]
      })
      this.dateList.push({
        text: this.getWeekday(new Date(this.GetDateStr(4)[0]).getDay()),
        date: this.GetDateStr(4)[0],
        dateText: this.GetDateStr(4)[1]
      })
      this.dateList.forEach((val, index) => {
        if (val.date === this.useStartDate) {
          this.selectDateIndex = index
        }
      })
    },
    getWeekday (day) {
      return ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][day]
    },
    cardtypeList () {
      cardtypeList().then(res => {
        if (res.code === 0) {
          this.certificateTypes = res.data
          this.hasIdCard = !!this.certificateTypes.find(val => val.code === '1')
        }
      })
    },
    // 验证手机号
    validateMobile (rule, value, callback) {
      if (value == null || value === '') {
        callback(new Error('请输入联系人手机号码'))
      } else {
        if (!validaCellPhone(value)) {
          callback(new Error('联系人手机号码格式不正确'))
        }
      }
      callback()
    },
    // 验证身份证
    validateCert (rule, value, callback) {
      if ((value == null || value === '') && this.needContactCardNo) {
        callback(new Error('请输入联系人身份证号'))
      } else {
        if (value && !validaIDCardNo(value)) {
          callback(new Error('联系人身份证号格式不正确'))
        }
      }
      callback()
    },
    qucikBuyCode () {
      qucikBuyCode().then(res => {
        if (res.code === 0) {
          this.codeshow = res.data.value !== 'F'
        }
      })
    },
    getVerificationCode () {
      if (!validaCellPhone(this.formData.contactMobile)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
      } else {
        const data = {
          templateId: 'SMS_T_BUYCODE',
          mobilePhone: this.formData.contactMobile
        }
        sendCode(data).then(res => {
          if (res.code === 0) {
            this.verificationBtn = false
            this.verificationTime = 60
            if (this.timer) {
              clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
              if (--this.verificationTime <= 0) {
                this.verificationBtn = true
                clearInterval(this.timer)
              }
            }, 1000)
          } else {
            this.$message({
              message: res.error,
              type: 'error'
            })
          }
        })
      }
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>
<style lang="scss">
.confirm-table-trip {
  &.el-table th, &.el-table tr, &.el-table--enable-row-hover .el-table__body tr:hover>td, .el-input__inner {
    background-color: #F5F5F7;
  }
  .el-input__inner {
    border: 1px solid #95A3AF
  }
  .el-input--mini .el-input__inner{
    height: 36px;
    line-height: 36px;
  }
  &.el-table td, &.el-table th.is-leaf {
    border-bottom: none;
  }
  .el-table--border::after, .el-table--group::after, &.el-table::before {
    background-color: #F5F5F7;
  }
  .el-icon-circle-close:before{
    font-size: 24px;
  }
  .delete-btn {
    width: 22px;
    height: 22px;
  }
}
</style>

<style scoped lang="scss">
.trip-book {
  padding: 40px;
  width: 1180px;
  margin-top: 22px;
  background: white;
  box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
  border-radius: 8px;
  .nodata {
    text-align: center;
    margin-top: 20px;
  }
  .ft16 {
    font-size: 16px;
  }
  .mt40 {
    margin-top: 40px;
  }
  .sub-til {
    margin-bottom: 19px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 22px;
    color: #A0393E;
    display: flex;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
  }
  .date-div{
    .other-date {
      border: none;
      background: #F5F5F7;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 19px;
      color: #9B232A;
      position: relative;
      img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
    }
  }
  .hide-date {
    position: absolute;
    z-index: -100;
    left: 0;
    top: 0;
  }
  .interval-list-div{
    margin-top: 28px;
  }
  .common-time-list {
    display: grid;
    grid-template-columns: 16% 16% 16% 16% 16% 16%;
    >div{
      border-radius: 4px;
      text-align: center;
      padding: 10px 0;
      margin-right: 32px;
      margin-bottom: 10px;
      text-align: center;
      cursor: pointer;
      border: 1px solid #A7AEBB;
      p {
        font-size: 18px;
        font-weight: bold;
        line-height: 22px;
        color: #1D263A;
      }
    }
    .font14 {
      font-size: 14px;
      font-weight: 400;
      margin-top: 5px;
    }
    .active {
      background-color: #9B232A;
      border: #9B232A 1px solid;
      font-weight: bold;
      color: #fff;
      p{
        color: #fff;
        // font-weight: bold;
      }
    }
    .disabled {
      border: 1px solid #e2e2e2;
      p {
        color: #979aa0;
      }
    }
  }
  .pro-list {
    >div {
      background: #F5F5F7;
      margin-top: 30px;
      padding: 36px;
      .flex-between {
        .name {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 24px;
          color: #1D263A;
        }
        .price {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 24px;
          color: #1D263A;
        }
        .c-r {
          color: #FF0000;
        }
      }
    }
  }
  .people-num {
    margin-top: 30px;
    .common-time-list {
      >div {
        margin-right: 62px;
        height: 44px;
        line-height: 44px;
        padding: 0;
      }
      .other-number {
        height: 44px;
        border: 1px solid #9B232A;
        opacity: 1;
        border-radius: 4px;
        /deep/ .el-input__inner:hover {
          border-color: transparent;
        }
        /deep/ .el-input__inner {
          background-color: transparent;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 22px;
          color: #9B232A;
          text-align: center;
          height: 44px;
          border: none;
        }
      }
    }
  }
}

.visitorMsg {
  background-color: #fff;
  margin-top: 20px;
}

.headline {
  line-height: 46px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #424855;
  height: 46px;
}

.headline .sub {
  font-size: 16px;
  font-weight: bold;
}

.visitorMsg .msgForm {
  padding-top: 13px;
  padding-bottom: 13px;
  border-bottom: 1px solid #ccc;
}
.visitorMsg .msgForm:nth-last-child(1) {
  border-bottom: none;
}
.submitOrder {
  background: #FFFFFF;
  box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
  opacity: 1;
  border-radius: 8px;
  padding: 20px;
  position: fixed;
  top: 102px;
  right: 100px;
  width: 186px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 19px;
  color: #1D263A;
  >div {
    margin-bottom: 19px;
  }
  .submitBtn {
    height: 32px;
    width: 154px;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    background: #9B232A;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    margin: 27px auto 0;
  }
  .submitBtn:active {
    opacity: 0.8;
  }
  .price {
    font-size: 20px;
    font-weight: bold;
  }
}
.num {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 22px;
  color: #9B232A;
}
</style>
